// ============================================================================
// modules/parametros/api/parametros.api.ts
// Capa HTTP del módulo Parámetros. Usa el httpClient centralizado (shared/api).
// Cada función normaliza la respuesta INCLUSO en error (nunca deja escapar
// error.response a la capa de UI). Migrado desde src/api/parametroApi.js.
// ============================================================================
import { httpClient } from "../../../shared/api/httpClient";

const errorNormalizado = (error: any, extra: Record<string, any> = {}): any => {
  if (error?.response && error.response.data?.status === 0) {
    return { status: error.response.data.status, message: error.response.data.message, ...extra };
  }
  return { status: -1, message: "Error en el servidor", ...extra };
};

export const parametroCrear = async (dataPOST) => {
  try {
    const res = await httpClient.post("api/parametro/AgregarParametro", dataPOST);
    if (res.data.status === 1) {
      return { status: res.data.status, message: res.data.message };
    }
  } catch (error) {
    return errorNormalizado(error);
  }
};

export const parametrosBuscar = async (dataPOST) => {
  try {
    const res = await httpClient.post("api/parametro/BuscarParametro", dataPOST);
    if (res.data.status === 1) {
      return { status: res.data.status, parametros: res.data.resultado, message: res.data.message };
    }
  } catch (error) {
    return errorNormalizado(error, { parametros: [] });
  }
};

export const parametroDelete = async (dataPOST) => {
  try {
    const res = await httpClient.post("api/parametro/EliminarParametro", dataPOST);
    if (res.data.status === 1) {
      return { status: res.data.status, message: res.data.message };
    }
  } catch (error) {
    return errorNormalizado(error);
  }
};

export const parametroMostrar = async (dataPOST) => {
  try {
    const res = await httpClient.post("api/parametro/MostrarParametro", dataPOST);
    if (res.data.status === 1) {
      return { status: res.data.status, parametro: res.data.resultado, message: res.data.message };
    }
  } catch (error) {
    return errorNormalizado(error, { parametro: null });
  }
};

export const parametroEditar = async (dataPOST) => {
  try {
    const res = await httpClient.post("api/parametro/ActualizarParametro", dataPOST);
    if (res.data.status === 1) {
      return { status: res.data.status, message: res.data.message };
    }
  } catch (error) {
    return errorNormalizado(error);
  }
};
